export default "__VITE_ASSET__DPOmuihS__"